// extracted by mini-css-extract-plugin
module.exports = {"root":"UserNav_root__130lL","tab":"UserNav_tab__3nYue"};